import React, { useState } from 'react';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumbs from '../components/Breadcrumbs';

function Contact() {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formData = new FormData(e.target);

        try {
            const response = await fetch("https://formspree.io/f/mlgnqrvr", {
                method: "POST",
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (response.ok) {
                setIsSubmitted(true);
                e.target.reset();
            } else {
                alert("Something went wrong. Please try again or email me directly.");
            }
        } catch (error) {
            alert("Something went wrong. Please check your connection and try again.");
        } finally {
            setIsSubmitting(false);
        }
    };
    return (
        <div className="relative flex h-auto min-h-screen w-full flex-col group/design-root overflow-x-hidden">
            <div className="layout-container flex h-full grow flex-col">
                <Header />

                <main className="flex-1 max-w-[1200px] mx-auto px-4 lg:px-10 py-10 w-full bg-slate-900/80 backdrop-blur-sm rounded-xl mt-8 mb-12">
                    <Breadcrumbs />
                    <div className="flex flex-col lg:flex-row gap-12">
                        {/* Left Side: Get in Touch & Info */}
                        <div className="flex-1 flex flex-col gap-8">
                            <div className="relative overflow-hidden rounded-xl bg-[#1a2333] p-8 border border-[#232f48] circuit-pattern" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(19, 91, 236, 0.15) 1px, transparent 0)', backgroundSize: '24px 24px' }}>
                                <div className="relative z-10">
                                    <h1 className="text-white tracking-light text-[32px] md:text-[40px] font-bold leading-tight pb-4">
                                        Get in Touch
                                    </h1>
                                    <p className="text-slate-300 text-base md:text-lg font-normal leading-relaxed mb-8 max-w-md">
                                        Specializing in IoT, R&amp;D, and technical leadership. Let's discuss your next innovative project or professional collaboration.
                                    </p>
                                    <div className="space-y-6">
                                        {/* Contact Detail */}
                                        <div className="flex items-center gap-4 group">
                                            <div className="size-12 rounded-lg bg-primary/20 flex items-center justify-center text-primary dark:text-sky-300 group-hover:bg-primary group-hover:text-white transition-all">
                                                <svg className="size-6" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path></svg>
                                            </div>
                                            <div>
                                                <p className="text-slate-400 text-xs font-bold uppercase tracking-wider">LinkedIn</p>
                                                <a className="text-white font-medium hover:text-primary break-all" href="https://www.linkedin.com/in/yavuzselimbostanci" target="_blank" rel="noopener noreferrer">linkedin.com/in/yavuzselimbostanci</a>
                                            </div>
                                        </div>
                                        {/* Contact Detail */}
                                        <div className="flex items-center gap-4 group">
                                            <div className="size-12 rounded-lg bg-primary/20 flex items-center justify-center text-primary dark:text-sky-300 group-hover:bg-primary group-hover:text-white transition-all">
                                                <span className="material-symbols-outlined">mail</span>
                                            </div>
                                            <div>
                                                <p className="text-slate-400 text-xs font-bold uppercase tracking-wider">Email</p>
                                                <a className="text-white font-medium hover:text-primary" href="mailto:yavuz@yavuzbostanci.com">yavuz@yavuzbostanci.com</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Abstract Map/Graphic */}
                            <div className="h-[200px] rounded-xl bg-cover bg-center border border-[#232f48] opacity-80" data-alt="Abstract geometric dark map showing connectivity nodes" data-location="Istanbul" style={{ backgroundImage: "linear-gradient(180deg, rgba(16, 22, 34, 0.4) 0%, rgba(16, 22, 34, 0.8) 100%), url('https://lh3.googleusercontent.com/aida-public/AB6AXuDk_YfmnVEGb7hO6shUyjGkk2zM-GW0afOentPDTzqzc0nxGSscaxN9DLRyuqGb7a6usAI8Hcglc4lyo7MXU1MdiCqWMOAdELMBtwIz190aUcvhyWckeOB510BxNQRIWre3mFT7I3FJSZK2aWs99fWck7hnQRz_EtsYIS9EnTFgqi7tYkgo1l-leb2zrw_FXXQrVPpxKfOda9nHKR8fuCXBOZ5OIdpY35mq14e6TZqO8TrSoW2AsUmTN3M7ryo0Q4uifvilkmxPzg')" }}>
                                <div className="p-6">
                                    <div className="inline-flex items-center gap-2 rounded-full bg-primary/30 px-3 py-1 text-xs font-bold text-white border border-primary/50">
                                        <span className="size-2 rounded-full bg-green-400 animate-pulse"></span>
                                        Available for worldwide R&amp;D projects
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Right Side: Contact Form */}
                        <div className="flex-1">
                            <div className="bg-[#1a2333]/50 rounded-xl p-8 border border-[#232f48] backdrop-blur-sm h-full flex flex-col justify-center">
                                {isSubmitted ? (
                                    <div className="flex flex-col items-center justify-center text-center py-12 animate-fade-in">
                                        <div className="size-20 rounded-full bg-green-500/20 flex items-center justify-center mb-6 text-green-500">
                                            <span className="material-symbols-outlined text-4xl">check_circle</span>
                                        </div>
                                        <h3 className="text-2xl font-bold text-white mb-3">Message Sent!</h3>
                                        <p className="text-slate-300 max-w-xs mx-auto">
                                            Thank you for reaching out. I'll get back to you as soon as possible.
                                        </p>
                                        <button
                                            onClick={() => setIsSubmitted(false)}
                                            className="mt-8 text-primary hover:text-primary/80 font-medium transition-colors"
                                        >
                                            Send another message
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        <h2 className="text-white text-2xl font-bold mb-6">Send a Message</h2>
                                        <form onSubmit={handleSubmit} className="space-y-5">
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                                <div className="flex flex-col gap-2">
                                                    <label className="text-sm font-medium text-slate-300">Full Name</label>
                                                    <input required name="name" className="bg-background-dark border border-[#232f48] rounded-lg p-3 text-white focus:outline-none focus:border-sky-300 focus:ring-1 focus:ring-sky-300 transition-all" placeholder="John Doe" type="text" />
                                                </div>
                                                <div className="flex flex-col gap-2">
                                                    <label className="text-sm font-medium text-slate-300">Email Address</label>
                                                    <input required name="email" className="bg-background-dark border border-[#232f48] rounded-lg p-3 text-white focus:outline-none focus:border-sky-300 focus:ring-1 focus:ring-sky-300 transition-all" placeholder="john@example.com" type="email" />
                                                </div>
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <label className="text-sm font-medium text-slate-300">Subject</label>
                                                <input required name="subject" className="bg-background-dark border border-[#232f48] rounded-lg p-3 text-white focus:outline-none focus:border-sky-300 focus:ring-1 focus:ring-sky-300 transition-all" placeholder="Project Inquiry" type="text" />
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <label className="text-sm font-medium text-slate-300">Your Message</label>
                                                <textarea required name="message" className="bg-background-dark border border-[#232f48] rounded-lg p-3 text-white focus:outline-none focus:border-sky-300 focus:ring-1 focus:ring-sky-300 transition-all resize-none" placeholder="Tell me about your ideas..." rows="6"></textarea>
                                            </div>
                                            <button
                                                type="submit"
                                                disabled={isSubmitting}
                                                className={`w-full bg-primary hover:bg-primary/90 text-white font-bold py-4 rounded-lg flex items-center justify-center gap-2 transition-all shadow-lg hover:shadow-primary/25 ${isSubmitting ? 'opacity-70 cursor-wait' : ''}`}
                                            >
                                                {isSubmitting ? (
                                                    <>
                                                        <span className="material-symbols-outlined animate-spin">refresh</span>
                                                        Sending...
                                                    </>
                                                ) : (
                                                    <>
                                                        <span className="material-symbols-outlined">send</span>
                                                        Send Message
                                                    </>
                                                )}
                                            </button>
                                            <p className="text-[11px] text-slate-400 text-center leading-relaxed px-2">
                                                By submitting this form, you consent to the collection and processing of your name and email address for the purpose of responding to your message. Your information will not be shared with third parties.
                                            </p>
                                        </form>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
                {/* Footer Section */}
                <Footer />
            </div>
        </div>
    );
}

export default Contact;

